import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

/**
 * Colonna di una `Table`.
 */
const HeaderColumn = ({ children, width }) => {
  const style = useMemo(() => (width ? { width } : undefined), [width]);
  return (
    <th style={style}>
      {children}
    </th>
  );
};

HeaderColumn.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),

  /** Larghezza della colonna (es. 125px). Se non definito, la colonna occuperà lo spazio libero  */
  width: PropTypes.string,
};

HeaderColumn.defaultProps = {
  children: null,
  width: null,
};

export default HeaderColumn;
